export default __webpack_public_path__ + "static/media/SignoutIcon.5ea4c705.svg";